import React from "react";
import { FormActions } from "../app";
import {
  QuotationEntityFields,
  QuotationHistoricalOptions,
  QuotationItemsEditor,
  QuotationNotesFields,
  QuotationTermsFields,
} from "./QuotationFormSections";

export function QuotationCreateForm({
  formData,
  setFormData,
  clients,
  projects,
  getEntityId,
  formatClientDisplay,
  getTodayDateInput,
  t,
  formatMoney,
  onSubmit,
  onCancel,
  onAddItem,
  onUpdateItem,
  onRemoveItem,
  onItbmsChange,
  onOpenCatalog,
}) {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <QuotationEntityFields
        formData={formData}
        setFormData={setFormData}
        clients={clients}
        projects={projects}
        getEntityId={getEntityId}
        formatClientDisplay={formatClientDisplay}
        t={t}
        clientLabel={t("clientRequired")}
      />

      <QuotationHistoricalOptions
        formData={formData}
        setFormData={setFormData}
        getTodayDateInput={getTodayDateInput}
      />

      <QuotationItemsEditor
        formData={formData}
        t={t}
        formatMoney={formatMoney}
        onAddItem={onAddItem}
        onUpdateItem={onUpdateItem}
        onRemoveItem={onRemoveItem}
        onItbmsChange={onItbmsChange}
        onOpenCatalog={onOpenCatalog}
      />

      <QuotationTermsFields formData={formData} setFormData={setFormData} t={t} />

      <QuotationNotesFields formData={formData} setFormData={setFormData} t={t} />

      <FormActions
        cancelLabel={t("cancel")}
        submitLabel={t("saveQuotation")}
        onCancel={onCancel}
        submitTestId="save-quotation-btn"
      />
    </form>
  );
}

export default QuotationCreateForm;
